import React from 'react';

export interface Props {
    href?: string;
    to?: string;
    destination?: string;
    children?: React.ReactNode;
}

const A = (props: Props) => {
    const destination = props.to || props.href || props.destination;
    return (
        <a href={destination} {...props}>
            {props.children}
        </a>
    );
};

export { A };
